import React, { useState } from "react";
import editIcon from "../../../assets/images/editIcon02.png"
import saveIcon from "../../../assets/images/Check.svg";
import clearIcon from "../../../assets/images/X.svg";
import SelectField from "./selectField";
import InputField from "./inputField";

const SocialMediaField = ({ name, id, onChange, options, optionList,
  defaultValue, defaultOption, setSelectedOption, placeholder, maxAllowed,
  minAllowed, required, showEditIcon=false, saveEdit,
  onEditClick,
  onCancelEdit,
  label,
  onFieldBlur
}) => {
  const [isEditable, setIsEditable] = useState(false);
  const [inputVal, setInputVal] = useState('');
  const [selectedOpt, setSelectedOpt] = useState('');
  const isOptionUpdate = true;
  const onOptionSelect = (id, value, isOptionUpdate) => {
    if (showEditIcon) {
      setSelectedOpt(value)
    }
    onSelect(id, value, isOptionUpdate)
  }

  const onInputChange = (id, value) => {
    if (showEditIcon) {
      setInputVal(value)
    }
    onChange(id, value)
  }

  const onSelect = (id, value, isOptionUpdate) => {
    setSelectedOption(id, value, isOptionUpdate)
  }

  const onSaveEdit = () => {
    if ((defaultOption === selectedOpt) && (defaultValue === inputVal)) {
      setIsEditable(false);
    } else {
      let isValueEdited = false;
      if (defaultOption || defaultValue) {
        isValueEdited = ((defaultOption !== selectedOpt) || (defaultValue !== inputVal));
      }
      if (!inputVal) {
        setSelectedOpt('')
        setIsEditable(false);
        onOptionSelect(id, '', true);
        return
      }
      saveEdit(id, isValueEdited, selectedOpt, inputVal, optionList)
      setIsEditable(false);
    }
  }
  const disableInputField = () => {
    if (showEditIcon && !(defaultOption || selectedOpt)) {
      return true;
    } else if (!showEditIcon && !(defaultOption || selectedOpt)) {
      return true;
    }
    return false;
  }

  const handleClear = () => {
    setInputVal('');
    setSelectedOpt('');
    setIsEditable(false)
    if (onCancelEdit) onCancelEdit();
  }

  return (
    <div className={`flex ${showEditIcon ? 'justify-between' : 'justify-start'}`}>
      <div className='flex flex-row gap-2'>
        <SelectField options={options} name={name} id={id} onChangeOption={onOptionSelect} defaultValue={defaultOption} customStyle="w-fit mt-1.5" isReadOnly={showEditIcon && !isEditable} required={required}
          onFieldBlur={onFieldBlur} onEditClick={onEditClick} onCancelEdit={onCancelEdit} label={label}
        />
        <InputField name={name} id={id} onChange={onInputChange} defaultValue={defaultValue} placeholder={placeholder}
          maxAllowed={maxAllowed} minAllowed={minAllowed} required={required} customStyle='mt-1.5' isReadOnly={disableInputField()}
          onFieldBlur={onFieldBlur} onEditClick={onEditClick} onCancelEdit={onCancelEdit} label={label}
        />
      </div>
      {showEditIcon && !isEditable && (
        <button
          type="button"
          aria-label="edit"
          data-action="edit"
          className="ml-ten -mt-1"
          onClick={() => {
            setIsEditable(true);
            if (onEditClick) onEditClick(label, true);
          }}
        >
          <img src={editIcon} alt="edit" className="h-4 w-4 cursor-pointer" />
        </button>
      )}

      {isEditable && (
        <div className="save-cancel-wrapper grid -mt-4 ml-2 gap-2">
          <button
            type="button"
            data-action="save"
            aria-label="save edit"
            className="w-4 h-4 cursor-pointer flex items-center justify-center"
            onClick={onSaveEdit}
          >
            <img src={saveIcon} alt="save" className="w-4 h-4" />
          </button>

          <button
            type="button"
            data-action="cancel"
            aria-label="cancel edit"
            className="w-4 h-4 cursor-pointer flex items-center justify-center"
            onClick={handleClear}
          >
            <img src={clearIcon} alt="cancel" className="w-4 h-4" />
          </button>
        </div>
      )}
    </div>
  )
}

export default SocialMediaField;